import { put, call } from 'redux-saga/effects'
import { handleError, analyticsApiService } from 'Services/ApiService.js'
import AnalyticsActions from 'Stores/Analytics/Actions'
import { encodeObjectToBase64 } from 'Utils/Base64Functions'

export function* fetchTopCities({ filter }) {
  yield put(AnalyticsActions.fetchTopCitiesLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/topCities`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchTopCitiesSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTopCitiesFail())
    handleError(e)
  }
}
export function* fetchPeakHour({ filter }) {
  yield put(AnalyticsActions.fetchPeakHourLoading())

  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/peakHour`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchPeakHourSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchPeakHourFail())
    handleError(e)
  }
}
export function* fetchAverageDuration({ filter }) {
  yield put(AnalyticsActions.fetchAverageDurationLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/averageDuration`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchAverageDurationSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchAverageDurationFail())
    handleError(e)
  }
}
export function* fetchTopVouchers({ filter }) {
  yield put(AnalyticsActions.fetchTopVouchersLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/topVouchers`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchTopVouchersSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTopVouchersFail())
    handleError(e)
  }
}
export function* fetchTopSites({ filter }) {
  yield put(AnalyticsActions.fetchTopSitesLoading())

  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/topSites`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchTopSitesSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTopSitesFail())
    handleError(e)
  }
}
export function* fetchOverview({ filter }) {
  yield put(AnalyticsActions.fetchOverviewLoading())

  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/overview`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchOverviewSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchOverviewFail())
    handleError(e)
  }
}
export function* fetchTransactionsStatistics({ filter }) {
  yield put(AnalyticsActions.fetchTransactionsStatisticsLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/transactionsStats`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchTransactionsStatisticsSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTransactionsStatisticsFail())
    handleError(e)
  }
}
export function* fetchUserSignup({ filter }) {
  yield put(AnalyticsActions.fetchUserSignupLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/userSignup`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchUserSignupSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchUserSignupFail())
    handleError(e)
  }
}

export function* fetchTopUsers({ filter }) {
  yield put(AnalyticsActions.fetchTopUsersLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/topUsers`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchTopUsersSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTopUsersFail())
    handleError(e)
  }
}
export function* fetchUsersActivity({ filter }) {
  yield put(AnalyticsActions.fetchUsersActivityLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/usersActivity`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchUsersActivitySuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchUsersActivityFail())
    handleError(e)
  }
}
export function* fetchUsersStatistics({ filter }) {
  yield put(AnalyticsActions.fetchUsersStatisticsLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/usersStats`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchUsersStatisticsSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchUsersStatisticsFail())
    handleError(e)
  }
}
export function* fetchEnergyChart({ filter }) {
  yield put(AnalyticsActions.fetchEnergyChartLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/energyChart`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchEnergyChartSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchEnergyChartFail())
    handleError(e)
  }
}
export function* fetchTimeForFirstCharge({ filter }) {
  yield put(AnalyticsActions.fetchTimeForFirstChargeLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(
      analyticsApiService.get,
      `/timeForFirstCharge`,
      {
        params: {
          filter: filter,
        },
      },
    )
    yield put(AnalyticsActions.fetchTimeForFirstChargeSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTimeForFirstChargeFail())
    handleError(e)
  }
}
export function* fetchTimeBetweenTrans({ filter }) {
  yield put(AnalyticsActions.fetchTimeBetweenTransLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/avgTimeBetTrans`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchTimeBetweenTransSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchTimeBetweenTransFail())
    handleError(e)
  }
}
export function* fetchPaymentBreakdown({ filter }) {
  yield put(AnalyticsActions.fetchPaymentBreakdownLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(analyticsApiService.get, `/paymentBreakdown`, {
      params: {
        filter: filter,
      },
    })
    yield put(AnalyticsActions.fetchPaymentBreakdownSuccess(data))
  } catch (e) {
    yield put(AnalyticsActions.fetchPaymentBreakdownFail())
    handleError(e)
  }
}
